import React from "react";
import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";

const Header = ({ title }) => {
	const data = useStaticQuery(graphql`
		query {
			headerPicture: file(relativePath: { eq: "header.jpg" }) {
				childImageSharp {
					fluid(srcSetBreakpoints: [480, 960, 1440, 1920], maxWidth: 1920) {
						...GatsbyImageSharpFluid_withWebp_noBase64
					}
				}
			}
		}
	`);

	return (
		<div className={`header`}>
			<Img
				fluid={{
					...data.headerPicture.childImageSharp.fluid,
				}}
				className={`header__picture`}
			/>
			<div className={`container`}>
				<div className={"text-center"}>
					<h1 className={`header__title`}>
						<span className={`header__title--rotate`}>{title}</span>
					</h1>
				</div>
			</div>
		</div>
	);
};

export default Header;
